
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import documentExecutionLinkDialogDescriptor from './DocumentExecutionLinkDialogDescriptor.json'
import Textarea from 'primevue/textarea'

export default defineComponent({
    name: 'document-execution-link-dialog',
    components: { Dialog, Textarea },
    props: { visible: { type: Boolean }, linkInfo: { type: Object }, embedHTML: { type: Boolean }, propDocument: { type: Object }, parameters: { type: Object } },
    emits: ['close'],
    data() {
        return {
            documentExecutionLinkDialogDescriptor,
            publicUrl: '',
            document: null as any,
            linkParameters: '' as string
        }
    },
    watch: {
        visible() {
            this.loadLink()
        },
        propDocument() {
            this.loadLink()
        },
        linkParameters() {
            this.loadLink()
        }
    },
    created() {
        this.loadLink()
    },
    methods: {
        loadLink() {
            this.loadDocument()
            this.loadParameters()
            this.getPublicUrl()
        },
        loadDocument() {
            this.document = this.propDocument
        },
        loadParameters() {
            if (this.parameters)
                this.linkParameters = Object.keys(this.parameters)
                    .map((key) => {
                        if (this.parameters && this.parameters[key] && Array.isArray(this.parameters[key])) {
                            let string = ''
                            this.parameters[key].forEach((item, index) => {
                                string += `${index !== 0 ? '&' : ''}${key}=${item}`
                            })
                            return string
                        } else return key + '=' + (this.parameters && this.parameters[key] ? this.parameters[key] : '')
                    })
                    .join('&')
        },
        getPublicUrl() {
            const tenant = (this.$store.state as any).user.organization

            if (!this.document) return

            if (this.document.typeCode === 'DATAMART' || this.document.typeCode === 'DOSSIER') {
                if (this.embedHTML) {
                    this.publicUrl = `<iframe width="600" height="600" src="${location.origin}${this.$route.fullPath}" frameborder="0"></iframe>`
                } else {
                    this.publicUrl = location.origin + this.$route.fullPath
                }
            } else {
                if (this.embedHTML) {
                    this.publicUrl = `<iframe width="600" height="600" src="${location.origin}/knowage${this.linkInfo?.isPublic ? '/public' : ''}/servlet/AdapterHTTP?ACTION_NAME=EXECUTE_DOCUMENT_ACTION&OBJECT_LABEL=${
                        this.document.label
                    }&TOOLBAR_VISIBLE=true&ORGANIZATION=${tenant}&NEW_SESSION=true&PARAMETERS=${encodeURIComponent(this.linkParameters)}" frameborder="0"></iframe>`
                } else {
                    this.publicUrl = `${location.origin}/knowage${this.linkInfo?.isPublic ? '/public' : ''}/servlet/AdapterHTTP?ACTION_NAME=EXECUTE_DOCUMENT_ACTION&OBJECT_LABEL=${this.document.label}&TOOLBAR_VISIBLE=true&ORGANIZATION=${tenant}&NEW_SESSION=true&PARAMETERS=${encodeURIComponent(
                        this.linkParameters
                    )}`
                }
            }
        },
        closeDialog() {
            this.$emit('close')
            this.publicUrl = ''
        }
    }
})
